import { cloneDeep } from "lodash";
import React, { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { JOBS_RELATED_FILTERS } from "../helpers/constants";

const Filters = ({
  onFilterValueChange,
  filterValues,
  executeSearch,
  onHide,
  appChoices,
  status = "",
}) => {
  const findFilterValuesByParent = (parentKey) => {
    return filterValues?.find((filterJaunt) => filterJaunt?.key === parentKey);
  };

  const onParentFilterChange = (parentKey) => {
    const parentFilter = findFilterValuesByParent(parentKey);

    if (parentFilter?.children?.length) {
      parentFilter.children = [];
      onFilterValueChange([
        ...filterValues?.filter((fv) => fv.key !== parentKey),
        parentFilter,
      ]);
    } else {
      parentFilter.children = [
        ...JOBS_RELATED_FILTERS(appChoices).find((fj) => fj.key === parentKey)
          ?.children,
      ];
      onFilterValueChange([
        ...filterValues?.filter((fv) => fv.key !== parentKey),
        parentFilter,
      ]);
    }
  };

  const onChildrenFilterChange = (parentKey, child) => {
    const parentFilter = findFilterValuesByParent(parentKey);

    if (parentFilter?.children.some((i) => i?.key === child?.key)) {
      onFilterValueChange([
        ...filterValues?.filter((fv) => fv?.key !== parentKey),
        {
          ...parentFilter,
          children: [
            ...parentFilter?.children.filter((c) => c.key !== child.key),
          ],
        },
      ]);
    } else {
      parentFilter.children.push(child);
      onFilterValueChange([
        ...filterValues?.filter((fv) => fv?.key !== parentKey),
        { ...parentFilter },
      ]);
    }
  };

  useEffect(() => {
    let filterValues = cloneDeep([...JOBS_RELATED_FILTERS(appChoices)]);

    if (status) {
      const statusIndex = filterValues.findIndex(
        (filterValue) => filterValue?.key === "status"
      );

      const contractStatusIndex = filterValues.findIndex(
        (filterValue) => filterValue?.key === "contractStatus"
      );

      if (status !== "Current" && status !== "Contract Sent") {
        filterValues[statusIndex].children = [
          ...filterValues[statusIndex]?.children?.filter((child) => {
            return child?.label === status;
          }),
        ];
      }

      if (status === "Current") {
        filterValues[statusIndex].children = filterValues[
          statusIndex
        ].children.filter(
          (child) =>
            child?.label !== "Completed" && child?.label !== "Cancelled"
        );
      } else if (status === "Contract Sent") {
        filterValues[contractStatusIndex].children = filterValues[
          contractStatusIndex
        ]?.children?.filter(
          (child) =>
            child?.label === "Contract Sent" ||
            child?.label === "Contract Viewed"
        );
      }

      onFilterValueChange(filterValues);
    } else {
      onFilterValueChange(filterValues);
    }
  }, [appChoices, status]);

  return (
    <>
      <div className="mt-1 w-100 d-flex justify-content-end filter-button">
        <Button
          variant="primary"
          onClick={() => {
            executeSearch();
            onHide();
          }}
        >
          Apply
        </Button>
      </div>
      {JOBS_RELATED_FILTERS(appChoices).map((parentFilter) => {
        return (
          <>
            <div className="mt-2" key={parentFilter?.key}>
              <Form.Check
                id={`parent-id-${parentFilter?.key}`}
                type="checkbox"
                className="xxlarge font-weight-bold"
                label={parentFilter?.label}
                size="lg"
                onChange={() => onParentFilterChange(parentFilter?.key)}
                checked={
                  parentFilter?.children?.length ===
                  findFilterValuesByParent(parentFilter?.key)?.children?.length
                }
              />
              <hr className="my-1" />
              <Row>
                {parentFilter?.children.map((childFilter) => {
                  return (
                    <Col xs={6}>
                      <Form.Check
                        id={`id-${childFilter?.key}`}
                        key={childFilter?.key}
                        type="checkbox"
                        className="xlarge ml-3"
                        label={childFilter?.label}
                        size="sm"
                        checked={findFilterValuesByParent(
                          parentFilter?.key
                        )?.children.some((i) => i?.key === childFilter?.key)}
                        onChange={() =>
                          onChildrenFilterChange(parentFilter?.key, childFilter)
                        }
                      />
                    </Col>
                  );
                })}
              </Row>
            </div>
          </>
        );
      })}
    </>
  );
};

export default Filters;
